// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"6c11d48c","275":"b2b168c4","852":"e8691059","912":"f525a1fa","920":"ae9f4e2d","934":"b3ca9489"}[chunkId] + ".css";
};